// extracted by mini-css-extract-plugin
module.exports = {"arrowContainer":"arrowContainer__5CXZolrnWbzXM","arrow":"arrow__UJ8gpS2tztl6D"};